import styled from 'styled-components';
import {MAIN_COLOR} from "../../../components/globalThemes";

export const PartnersSection = styled.div`
    min-height: 450px;
    justify-content: center;
    border-top: 2px solid ${MAIN_COLOR};
    overflow: hidden;
    display: flex;
    flex-direction: row;
    width: 100%;
    
    @media (max-width: 1140px) {
        flex-direction: column;
    }
`;

export const PartnersBlock = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;

export const IconsContainer = styled.div`
    margin-left: -200px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    
    @media (max-width: 900px) {
        margin-left: -100px;
    }
    
    @media (max-width: 1140px) {
        margin-left: 0;
        margin-top: 70px;
        margin-bottom: 70px;
    }
`;

export const PartnersInfo = styled.div`
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #1c1f1c99;
    clip-path: polygon(0 0, 91% 0, 54% 28%, 80% 29%, 15% 91%, 0 100%); 
    
    @media (max-width: 900px) {
        clip-path: polygon(0 0, 91% 0, 54% 28%, 80% 29%, 35% 91%, 0 100%); 
    }
    
    @media (max-width: 1140px) {
        clip-path: none;
    }
`;

export const Hashtag = styled.p`
    color: ${MAIN_COLOR};
    font-family: BlenderProBold, serif;
    letter-spacing: 2px;
    margin-top: 40px;
    &:before {
        content: "#";
    }    
`;
